import useViewport from 'hooks/useViewport'

/**
 * * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('context/ViewportContext/types').Viewport} Viewport
 */

/**
 * @typedef {Object} Props
 * @property {ReactNode} [children]
 * @property {ReactNode} [renderIf]
 * @property {ReactNode} [renderOr]
 * @property {Viewport} [is]
 * @property {Viewport} [up]
 * @property {Viewport} [down]
 * @property {[Viewport, Viewport]} [between]
 */

/**
 * @param {Props} props
 */
const ServerViewport = ({
  children = null,
  renderIf = null,
  renderOr = null,
  is: isViewport,
  up: upViewport,
  down: downViewport,
  between: betweenViewports,
}) => {
  const { is, up, down, between } = useViewport()

  if (isViewport) {
    return is(isViewport) ? renderIf || children : renderOr
  }

  if (upViewport) {
    return up(upViewport) ? renderIf || children : renderOr
  }

  if (downViewport) {
    return down(downViewport) ? renderIf || children : renderOr
  }

  if (betweenViewports?.length == 2) {
    const [from, to] = betweenViewports
    return between(from, to) ? renderIf || children : renderOr
  }

  return null
}

export default ServerViewport
